<template>
  <div id="achievements">
    <article>
      <h1 class="main-title">הישגים משפטיים</h1>
    </article>

    <article>
      <allAchievements id="allAchievements" />
    </article>

    <article>
      <copyRights id="copyRights" />
    </article>
  </div>
</template>

<script>
import allAchievements from "@/components/AllAchievements.vue";
import copyRights from "@/components/CopyRights.vue";

export default {
  name: "achievements",
  components: {
    allAchievements,
    copyRights
  },
  metaInfo() {
    return {
      title: "איילת נוף הישגים משפטיים",
      meta: [
        {
          name: "description",
          content:
            'ניתן לראות חלק מן ההישגים המשפטיים של עו"ד איילת נוף אשר בתחומים שונים ומגוונים'
        }
      ]
    };
  }
};
</script>

<style scoped>
#allAchievements {
  width: 70%;
  margin: 0 auto;
  padding-top: 1vh;
}
#copyRights {
  padding-top: 0.75rem;
}
</style>
